import {
  BulkFilterTooManyMatchesResponseSchema,
  type BulkFilterTooManyMatchesResponseDto,
} from '@terra/shared-contracts-findings';

export function parseFindingsBulkConflictBody(
  body: unknown,
): BulkFilterTooManyMatchesResponseDto | null {
  const parsed = BulkFilterTooManyMatchesResponseSchema.safeParse(body);

  return parsed.success ? parsed.data : null;
}

export function resolveFindingsBulkConflictToast({
  body,
  copy,
}: {
  body: unknown;
  copy: {
    tooManyTitle: string;
    tooManyDescription: (values: {
      matchedCount: number;
      limit: number;
    }) => string;
    unsupportedAutoPublishedTitle: string;
    unsupportedAutoPublishedDescription: string;
    genericFailedTitle: string;
    genericFailedDescription: string;
  };
}): {
  title: string;
  description: string;
} {
  const conflict = parseFindingsBulkConflictBody(body);

  if (conflict?.reason === 'UNSUPPORTED_AUTO_PUBLISHED_FILTER') {
    return {
      title: copy.unsupportedAutoPublishedTitle,
      description: copy.unsupportedAutoPublishedDescription,
    };
  }

  if (conflict?.reason === 'TOO_MANY_MATCHES') {
    return {
      title: copy.tooManyTitle,
      description: copy.tooManyDescription({
        matchedCount: conflict.matchedCount,
        limit: conflict.limit,
      }),
    };
  }

  return {
    title: copy.genericFailedTitle,
    description: copy.genericFailedDescription,
  };
}
